/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { setLangRequestV4Schema } from './setLangRequestV4Schema'
import { stringApiResponseObjectV4Schema } from './stringApiResponseObjectV4Schema'

export const meSetLangStatus200Schema = stringApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const meSetLangStatus400Schema = stringApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const meSetLangResponseSchema = meSetLangStatus200Schema

export const meSetLangErrorSchema = meSetLangStatus400Schema

export const meSetLangBodySchemaJsonPatchJson = setLangRequestV4Schema.optional()

export const meSetLangBodySchemaJson = setLangRequestV4Schema.optional()

export const meSetLangBodySchemaJson2 = setLangRequestV4Schema.optional()

export const meSetLangBodySchemaJson3 = setLangRequestV4Schema.optional()

export const meSetLangBodySchema = z.union([
  meSetLangBodySchemaJsonPatchJson,
  meSetLangBodySchemaJson,
  meSetLangBodySchemaJson2,
  meSetLangBodySchemaJson3,
])
